
import React from 'react';
import { Switch } from '@/components/ui/switch';

interface CountryStatusProps {
  active: boolean;
  onToggle: () => void;
}

export const CountryStatus: React.FC<CountryStatusProps> = ({ active, onToggle }) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={active}
        onCheckedChange={onToggle}
      />
      <span>
        {active ? 'Active' : 'Inactive'}
      </span>
    </div>
  );
};
